export default "__VITE_ASSET__B$7$$LfC__"